import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select, {
  SelectOption,
} from '@iso/components/cbuielements/selectLanguage';
import config from '@iso/containers/LanguageSwitcher/config';
import actions from '@iso/redux/languageSwitcher/actions';
import LanguageSwitcherWrapper from './LanguageSwitcher.styles';

const { changeLanguage } = actions;

export default function LanguageSwitcher() {
  const { language } = useSelector((state) => state.LanguageSwitcher);
  /*  const [languageId] = useState(
    language.languageId
      ? language.languageId
      : localStorage.getItem('selectLanguage')
      ? localStorage.getItem('selectLanguage')
      : 'english'
  );*/

  const [languageId] = useState(
    localStorage.getItem('selectLanguage')
      ? localStorage.getItem('selectLanguage')
      : language.languageId
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(changeLanguage(languageId));
  }, [dispatch, languageId]);

  return (
    <LanguageSwitcherWrapper>
      <Select
        className="language-switcher"
        defaultValue={languageId}
        onChange={(languageId) => {
          localStorage.setItem('selectLanguage', languageId);
          localStorage.setItem(
            'selectLocale',
            config.options.find((lang) => lang.languageId === languageId).locale
          );
          dispatch(changeLanguage(languageId));
        }}
      >
        {config.options.map((option) => {
          const { languageId, icon } = option;
          return (
            <SelectOption
              key={languageId}
              onClick={() => {
                dispatch(changeLanguage(languageId));
              }}
              value={languageId}
            >
              <img
                src={icon}
                alt="flag"
                style={{ height: '30px', width: '30px' }}
              />
            </SelectOption>
          );
        })}
      </Select>
    </LanguageSwitcherWrapper>
  );
}
